export var MuiIconButtonOverrides = {
  defaultProps: {
    color: 'secondary',
    size: 'medium'
  },
  styleOverrides: {
    sizeLarge: {
      height: 48,
      width: 48,
      svg: {
        fontSize: '1.5rem'
      },
      padding: '12px'
    },
    sizeMedium: {
      height: 40,
      width: 40,
      padding: '10px',
      svg: {
        fontSize: '1.25rem'
      }
    },
    sizeSmall: {
      height: 32,
      width: 32,
      padding: '4px',
      svg: {
        fontSize: '1.25rem'
      }
    }
  }
};